import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

// Utils component
import TextError from "utils/TextError";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// React-Select component and styling
import "./style.css";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Dashboard layout components

// Dashboard example components
// import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Functions from store
import { clientRegister } from "../../../store";

// Router Components
import { useNavigate } from "react-router-dom";

// Images

import Footer from "layouts/authentication/components/Footer";

// @mui material
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";

// Cookies
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Registration = ({ clientRegister }) => {
  const notify = () => {
    toast.error("Invaid OTP", {
      position: "top-center",
    });
  };
  const notifyForOtp = () => {
    toast.success("Check your Email", {
      position: "top-center",
    });
  };

  const notifyForEmailOtp = () => {
    toast.warning("Email already Exist", {
      position: "top-center",
    });
  };

  const notifyForFailOtp = () => {
    toast.error("Server error", {
      position: "top-center",
    });
  };

  const styleForOtp = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 310,
    boxShadow: 24,
    // p: 1,
    pt: 3,
  };
  const disab1 = {
    PointerEvent: "none",
  };
  const nodisabl = {
    pointer: "cursor",
  };
  const cookies = new Cookies();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const navigate = useNavigate();
  const [hash, setHash] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const query = window.location.search.substring(1);
  const uuid = query.split("=")[1];
  let [emailForOtp, setEmailForOtp] = useState("");
  const [client, setClient] = useState(true);

  useEffect(() => {
    cookies.remove("mobillor-talent-accelerator-user-data");
  }, []);

  const [referencedByOptions, setReferencedByOptions] = useState([]);

  const [selectedReferencedBy, setSelectedReferencedBy] = useState("");

  const handleReferencedBy = (selectedReferencedBy) => {
    setSelectedReferencedBy(selectedReferencedBy);
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const intervalRef = useRef(null);
  const [timer, setTimer] = useState("00:00");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  function getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));

    return { total, days, hours, minutes, seconds };
  }

  function startTimer(deadline) {
    let { total, minutes, seconds } = getTimeRemaining(deadline);
    if (total >= 0) {
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds),
      );
    } else {
      clearInterval(intervalRef.current);
    }
  }

  function clearTimer(endtime) {
    setTimer("02:00");
    if (intervalRef.current) clearInterval(intervalRef.current);
    const id = setInterval(() => {
      startTimer(endtime);
    }, 1000);
    intervalRef.current = id;
  }
  function getDeadlineTime() {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 120);
    return deadline;
  }

  const initialValuesForClientRequest = {
    companyName: "",

    dataName: "",
    email: "",
    userName: "",
  };

  const validationSchemaForClientRequest = Yup.object({
    companyName: Yup.string()
      .required("Enter the Company Name")
      .min(3, "Company Name must be at least 3 characters"),

    dataName: Yup.string().required("Enter the Full Name"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Enter the Email"),
    userName: Yup.string()
      .required("Enter the User Name")
      .matches(/^\S*$/, "User Name cannot contain spaces"),
  });
  const [loadingForOpenOtpModel, setLoadingForOpenOtpModel] = useState(false);
  const [isErrorCreateUser, setIsErrorCreateUser] = useState(false);
  const [isSuccessCreateUser, setIsSuccessCreateUser] = useState(false);
  const [isErrorForEmail, setIsErrorForEmail] = useState(false);

  useEffect(() => {
    if (isSuccessCreateUser) {
      setTimeout(() => {
        setIsSuccessCreateUser(false);
      }, 3000);
    }
  }, [isSuccessCreateUser]);

  useEffect(() => {
    if (isErrorCreateUser) {
      setTimeout(() => {
        setIsErrorCreateUser(false);
      }, 3000);
    }
  }, [isErrorCreateUser]);

  const [isErrorForGenerateOtp, setIsErrorForGenerateOtp] = useState(false);
  const [isSuccessForGenerateOtp, setIsSuccessForGenerateOtp] = useState(false);

  const onSubmitForClientRequest = async (values, { resetForm }) => {
    let response = await clientRegister(values);
    if (response.status === true) {
      setLoading(true);
      setIsSuccessCreateUser(true);
      setTimeout(() => {
        setLoading(false);
        navigate("/login");
      }, 3000);
    }
    if (response.status === false) {
      setIsErrorCreateUser(true);
      setErrorMessage(response?.data?.data?.message);
    }
  };
  const formikForClientRequest = useFormik({
    initialValues: initialValuesForClientRequest,
    onSubmit: onSubmitForClientRequest,
    validationSchema: validationSchemaForClientRequest,
  });

  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [color, setColor] = useState("red");
  const [verifyEmailError, setVerifyEmailError] = useState(
    "Please verify the Email!",
  );
  const [emailVerified, setEmailVerified] = useState(false);
  const [active, setActive] = useState(false);

  const handleEmailChange = () => {
    setActive(true);
  };

  const handleOpenOtpModal = () => {
    setOpenOtpModal(true);
  };

  const handleCloseOtpModal = () => {
    setOpenOtpModal(false);
  };

  let emailOtp = formikForClientRequest.values.email;
  let name = formikForClientRequest.values.dataName;

  let payload = {
    name: name,
    email: emailOtp,
  };

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      height: "fit-content",
      maxHeight: 200,
      overflow: "auto",
    }),
  };

  let topbutton = "SIGN IN";
  let pagelink = "/login";
  let topbutton5 = "Existing client?";
  return (
    <>
      <style>
        {`
        @media (max-width: 900px) {
          .container {
            width: 100% !important;
            padding: 0 10px !important;
          }
          .form {
            margin-top: 30px !important;
            width: 100% !important;
            min-width: unset !important;
          }
          .contact-form {
            padding: 10px !important;
            width: 100% !important;
            min-width: unset !important;
          }
        }
        @media (max-width: 600px) {
          .container {
            padding: 0 2vw !important;
           
          }
          .form {
            margin-top: 20px !important;
            width: 100% !important;
          }
          .contact-form {
            padding: 0 !important;
            width: 100% !important;
          }
          .MuiInputBase-root, .MuiFormControl-root {
            font-size: 14px !important;
          }
          .MuiTypography-h4 {
            font-size: 1.3rem !important;
          }
        }
        @media (max-width: 400px) {
          .form {
            margin-top: 10px !important;
          }
          .MuiTypography-h4 {
            font-size: 1rem !important;
          }
        }
      `}
      </style>
      <DefaultNavbar
        topbutton={topbutton}
        pagelink={pagelink}
        topbutton5={topbutton5}
      />

      <div className="container">
        <div className="form" style={{ marginTop: "60px" }}>
          <div class="contact-form">
            <MDBox>
              <MDBox pt={1} pb={1} overflow="auto">
                <>
                  <MDBox pb={0}>
                    <MDBox pb={0}>
                      <MDBox
                        component="form"
                        role="form"
                        onSubmit={formikForClientRequest.handleSubmit}
                      >
                        <MDTypography
                          variant="h4"
                          fontWeight="medium"
                          mt={{ xs: 0, md: -2 }}
                        >
                          Registration
                        </MDTypography>
                        <MDBox mb={2} mt={2}>
                          <MDInput
                            maxLength={10}
                            label="Full Name"
                            type="text"
                            name="dataName"
                            fullWidth
                            autoComplete="off"
                            onChange={formikForClientRequest.handleChange}
                            onBlur={formikForClientRequest.handleBlur}
                            value={formikForClientRequest.values.dataName}
                            error={
                              formikForClientRequest.touched.dataName &&
                              formikForClientRequest.errors.dataName &&
                              true
                            }
                          />
                          {formikForClientRequest.touched.dataName &&
                            formikForClientRequest.errors.dataName && (
                              <TextError
                                msg={formikForClientRequest.errors.dataName}
                              />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDInput
                            maxLength={10}
                            label="User Name"
                            type="text"
                            name="userName"
                            fullWidth
                            autoComplete="off"
                            onChange={formikForClientRequest.handleChange}
                            onBlur={formikForClientRequest.handleBlur}
                            value={formikForClientRequest.values.userName}
                            error={
                              formikForClientRequest.touched.userName &&
                              formikForClientRequest.errors.userName &&
                              true
                            }
                            onKeyDown={(e) => {
                              if (e.key === " ") {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formikForClientRequest.touched.userName &&
                            formikForClientRequest.errors.userName && (
                              <TextError
                                msg={formikForClientRequest.errors.userName}
                              />
                            )}
                        </MDBox>
                        <MDBox mb={2}>
                          <MDInput
                            label="Company Name"
                            type="text"
                            name="companyName"
                            fullWidth
                            autoComplete="off"
                            onChange={formikForClientRequest.handleChange}
                            onBlur={formikForClientRequest.handleBlur}
                            value={formikForClientRequest.values.companyName}
                            error={
                              formikForClientRequest.touched.companyName &&
                              formikForClientRequest.errors.companyName &&
                              true
                            }
                          />
                          {formikForClientRequest.touched.companyName &&
                            formikForClientRequest.errors.companyName && (
                              <TextError
                                msg={formikForClientRequest.errors.companyName}
                              />
                            )}
                        </MDBox>

                        {/* {
                          formikForClientRequest.values.dataName && */}
                        <MDBox mb={2}>
                          <MDInput
                            label="Email"
                            type="email"
                            fullWidth
                            name="email"
                            autoComplete="off"
                            onChange={formikForClientRequest.handleChange}
                            onBlur={formikForClientRequest.handleBlur}
                            value={formikForClientRequest.values.email}
                            error={
                              formikForClientRequest.touched.email &&
                              formikForClientRequest.errors.email &&
                              true
                            }
                          />

                          {formikForClientRequest.touched.email &&
                            formikForClientRequest.errors.email && (
                              <TextError
                                msg={formikForClientRequest.errors.email}
                              />
                            )}
                        </MDBox>
                        {/* } */}

                        <MDBox mb={2}>
                          <Collapse in={isErrorCreateUser}>
                            <Alert
                              severity="error"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsErrorCreateUser(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              {errorMessage}
                            </Alert>
                          </Collapse>
                          <Collapse in={isSuccessCreateUser}>
                            <Alert
                              severity="success"
                              action={
                                <IconButton
                                  aria-label="close"
                                  color="inherit"
                                  size="small"
                                  onClick={() => {
                                    setIsSuccessCreateUser(false);
                                  }}
                                >
                                  <CloseIcon fontSize="inherit" />
                                </IconButton>
                              }
                            >
                              New client registered successfully
                            </Alert>
                          </Collapse>
                        </MDBox>

                        <MDBox mb={-3}>
                          <MDButton
                            style={{ backgroundColor: "red", float: "right" }}
                            color="info"
                            type="submit"
                            disabled={!formikForClientRequest.isValid}
                          >
                            Register
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </>
              </MDBox>
            </MDBox>
          </div>
        </div>

        <Footer />
      </div>
      <MDBox></MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {loadingForOpenOtpModel && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <ToastContainer />
    </>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    clientRegister: (payload) => dispatch(clientRegister(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Registration);
